import "prismjs";
import "./prism-markup";
import "./prism-csharp";
import "prismjs/components/prism-cshtml";
